import { Switch, Route, withRouter } from 'react-router-dom';
import RccapDetail from '@nkr/views/reports/rccap-detail';
import NkrReferralDonatedNkr from '@nkr/views/reports/nkr-referral-donated-nkr';
import AccountsPayable from '@nkr/views/reports/accounts-payable';
import AccountsPayableOpo from '@nkr/views/reports/accounts-payable-opo';
import AccountsReceivable from '@nkr/views/reports/accounts-receivable';
import MicrositeCoachPerformance from '@nkr/views/reports/microsite-coach-performance/microsite-coach-performance';
import AccountsPayablePayment from '@nkr/views/reports/accounts-payable-payment/accounts-payable-payment';
import AccountsPayableOpoPayment from '@nkr/views/reports/accounts-payable-opo-payment/accounts-payable-opo-payment';

const AdminReportRoutes = (params) => {
    let url = params.url;

    return (
        <Switch>
            <Route path={`${url}/rccap-detail`} component={RccapDetail} />
            <Route path={`${url}/nkr-referral-donated-nkr`} render={() => <NkrReferralDonatedNkr />} />
            <Route path={`${url}/accounts-receivable`} component={AccountsReceivable} />
            <Route path={`${url}/accounts-payable`} component={AccountsPayable} />
            <Route path={`${url}/accounts-payable-payment`} component={AccountsPayablePayment} />
            <Route path={`${url}/accounts-payable-opo`} component={AccountsPayableOpo} />
            <Route path={`${url}/accounts-payable-opo-payment`} component={AccountsPayableOpoPayment} />
            <Route path={`${url}/microsite-coach-performance`} render={() => <MicrositeCoachPerformance isSuperAdmin={true} />} />
        </Switch>
    );
}

export default withRouter(AdminReportRoutes);